module.exports = __webpack_public_path__ + "img/logo-jxfgw.64157a62.jpg";